import { Link } from 'react-router'
import styled from 'styled-components'
import { accents, gray } from 'sutra/tokens/colors'

import { askYogiTokens as t } from 'features/ask-yogi/styles/tokens'

// The chat message wrapper styles every descendant `a` (class + element
// specificity), which would beat a single-class rule here — `&&` doubles the
// class so the link's own color and underline win. Same grey as the date it
// sits beside; navy plus the underline on hover is the link cue.
export const ProductLink = styled(Link)`
  && {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: ${t.fontSize.caption};
    color: ${gray[400]};
    text-decoration: none;

    &:hover {
      color: ${accents.reflectionBlue[700]};
      text-decoration: underline;
    }
  }
`
